"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putStatsDataToDynamoDb = putStatsDataToDynamoDb;
exports.getStatsDataFromDynamoDb = getStatsDataFromDynamoDb;
exports.mapResponseToAnalyticsData = mapResponseToAnalyticsData;
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const logger_js_1 = require("../logger.js");
async function putStatsDataToDynamoDb(params) {
    const STATS_TABLE_NAME = process.env.STATS_TABLE_NAME;
    const tableName = params.tableName ? params.tableName : STATS_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    if (!tableName)
        throw new Error("stats table name not found");
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    try {
        const statsData = params.statsData;
        const promises = Object.entries(statsData).map(async ([key, value]) => {
            const item = {
                name: key,
                value: value,
            };
            const command = new lib_dynamodb_1.PutCommand({
                TableName: tableName,
                Item: item,
            });
            await ddbDocClient.send(command);
        });
        await Promise.all(promises);
    }
    catch (error) {
        (0, logger_js_1.logError)("Failed to write stats data to DynamoDB", {
            component: "stats",
            operation: "putStatsDataToDynamoDb",
            error: error instanceof Error ? error : new Error(String(error)),
        });
    }
}
async function getStatsDataFromDynamoDb(params) {
    const STATS_TABLE_NAME = process.env.STATS_TABLE_NAME;
    const tableName = params.tableName ? params.tableName : STATS_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const itemNames = [
        "historicalTVL",
        "latestTVL",
        "dailyRevenue",
        "annualisedRevenue",
        "totalAlphaStakers",
        "treasuryTotalHoldingsUsd",
        "treasuryAlphaHolding",
        "treasuryHoldingsDistribution",
        "circulatingAlphaSupply",
        "maxAlphaSupply",
        "treasurySharePerAlpha",
        "airdropApr",
        "alphaHistoricalMarketCap",
    ];
    const requestItems = {
        [tableName]: {
            Keys: itemNames.map((name) => ({ name: { S: name } })),
        },
    };
    try {
        const command = new client_dynamodb_1.BatchGetItemCommand({ RequestItems: requestItems });
        const response = await ddbDocClient.send(command);
        const items = response.Responses ? response.Responses[tableName] : [];
        return items;
    }
    catch (error) {
        (0, logger_js_1.logError)("Failed to fetch stats data from DynamoDB", {
            component: "stats",
            operation: "getStatsDataFromDynamoDb",
            error: error instanceof Error ? error : new Error(String(error)),
        });
        throw error;
    }
}
function parseDynamoDBAttribute(attr) {
    if ("S" in attr)
        return attr.S;
    if ("N" in attr)
        return Number(attr.N);
    if ("L" in attr)
        return attr.L.map(parseDynamoDBAttribute);
    if ("M" in attr) {
        const mapResult = {};
        for (const [key, value] of Object.entries(attr.M)) {
            mapResult[key] = parseDynamoDBAttribute(value);
        }
        return mapResult;
    }
    return undefined;
}
function mapResponseToAnalyticsData(dynamoResponse) {
    const result = {};
    dynamoResponse.forEach((item) => {
        const key = item.name.S;
        const value = parseDynamoDBAttribute(item.value);
        // Map the key to the result object
        switch (key) {
            case "historicalTVL":
                result.historicalTVL = value;
                break;
            case "latestTVL":
                result.latestTVL = value;
                break;
            case "dailyRevenue":
                result.dailyRevenue = value;
                break;
            case "annualisedRevenue":
                result.annualisedRevenue = value;
                break;
            case "totalAlphaStakers":
                result.totalAlphaStakers = value;
                break;
            case "treasuryTotalHoldingsUsd":
                result.treasuryTotalHoldingsUsd = value;
                break;
            case "treasuryAlphaHolding":
                result.treasuryAlphaHolding = value;
                break;
            case "treasuryHoldingsDistribution":
                result.treasuryHoldingsDistribution = value;
                break;
            case "circulatingAlphaSupply":
                result.circulatingAlphaSupply = value;
                break;
            case "maxAlphaSupply":
                result.maxAlphaSupply = value;
                break;
            case "treasurySharePerAlpha":
                result.treasurySharePerAlpha = value;
                break;
            case "airdropApr":
                result.airdropApr = value;
                break;
            case "alphaHistoricalMarketCap":
                result.alphaHistoricalMarketCap = value;
                break;
            default:
                (0, logger_js_1.logWarning)("Unrecognized key in analytics data mapping", {
                    component: "stats",
                    operation: "mapResponseToAnalyticsData",
                    context: { key },
                });
        }
    });
    return result;
}
//# sourceMappingURL=stats.js.map